import { OsmAPIList } from '@/api'

const api = new OsmAPIList();

export default {
  getProviderList({ state, commit }, params) {
    return new Promise((resolve, reject) => {
      api.getProviderList(params, (json) => {
        switch (json.status) {
          case 200:
            resolve(json);
            break;
          default:
            reject(json);
            break;
        }
      }, (err) => {
        reject(err);
      })
    })
  },

  editProvider({ state, commit }, params) {
    return new Promise((resolve, reject) => {
      api.editProvider(params, (json) => {
          switch (json.status) {
            case 200:
              resolve(json);
              break;
            default:
              reject(json);
              break;
          }
        },
        (err) => {
          reject(err);
        })
    })
  },

  createProvider({ state, commit }, params) {
    return new Promise((resolve, reject) => {
      api.createProvider(params, (json) => {
        switch (json.status) {
          case 200:
            resolve(json);
            break;
          default:
            reject(json);
            break;
        }
      }, (err) => {
        reject(err);
      })
    })
  },

  deleteProvider({ state }, ID) {
    return new Promise((resolve, reject) => {
      api.deleteProvider(ID, (json) => {
        switch (json.status) {
          case 200:
            resolve(json);
            break;
          default:
            reject(json);
            break;
        }
      }, (err) => {
        reject(err);
      })
    })
  },
}



// WEBPACK FOOTER //
// ./src/Osm/Provider/store/actions.js